import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de, { type Dict } from './de';
import en from './en';
import tr from './tr';

declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: 'translation';
    resources: { translation: Dict };
  }
}

function initialLanguage(): string {
  try {
    const saved = localStorage.getItem('pz-lang');
    if (saved === 'de' || saved === 'en' || saved === 'tr') return saved;
  } catch {
    /* storage not available */
  }
  // German by default; after sign-in the language stored in the person's profile applies
  return 'de';
}

void i18n.use(initReactI18next).init({
  resources: { de: { translation: de }, en: { translation: en }, tr: { translation: tr } },
  lng: initialLanguage(),
  fallbackLng: 'de',
  interpolation: { escapeValue: false },
  returnNull: false,
});
document.documentElement.lang = i18n.language;

export function setLanguage(lang: 'de' | 'en' | 'tr') {
  void i18n.changeLanguage(lang);
  document.documentElement.lang = lang;
  try {
    localStorage.setItem('pz-lang', lang);
  } catch {
    /* storage not available */
  }
}

export default i18n;
